import { render, staticRenderFns } from "./register-two-factor-authen.vue?vue&type=template&id=1ec98f04"
import script from "./register-two-factor-authen.vue?vue&type=script&lang=js"
export * from "./register-two-factor-authen.vue?vue&type=script&lang=js"
import style0 from "./register-two-factor-authen.vue?vue&type=style&index=0&id=1ec98f04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports